<template>
  <p class="text-caption text-red-500 reading-dark:text-red-50 self-stretch">
    <slot />
  </p>
</template>
